import { createContext, ReactNode } from "react";

export const TranslationLineLabelsContext = createContext<readonly [ReactNode, ReactNode] | undefined>(undefined);
